module.exports = __webpack_public_path__ + "static/media/corporate_fare_sponsor_selected.d5950528.svg";